import React, { createRef, useState } from 'react'
import { Switch } from 'react-router-dom'
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles'
// core components
import { Redirect } from 'react-router'
import Navbar from 'components/navbar/Navbar.jsx'
import Sidebar from 'components/sidebar/Sidebar.jsx'
import styles from 'assets/jss/dorm-app/layouts/appStyle.js'
import logo from 'assets/img/logo.png'
import AuthenticatedRoute from '../components/login/AuthenticatedRoute'

import { adminRoutes } from '../routes/adminRoutes'
import { finanzenDepartmentRoutes } from '../routes/finanzenDepartmentRoutes'
import { heimratDepartmentRoutes } from '../routes/heimratDepartmentRoutes'
import { infoDepartmentRoutes } from '../routes/infoDepartmentRoutes'
import { zimmerDepartmentRoutes } from '../routes/zimmerDepartmentRoutes'
import { departureRoutes } from '../routes/departmentRoutes'
import { individualTenantRoutes } from '../routes/individualTenantRoutes'
import { schlichtungDepartmentRoutes } from '../routes/schlichtungDepartmentRoutes'

const useStyles = makeStyles(styles)

function determineUserRoutes(user) {
  let routes = []

  if (user.authorities.includes('VERWALTUNG')) routes = routes.concat(adminRoutes)

  if (user.authorities.includes('HEIMRAT')) routes = routes.concat(heimratDepartmentRoutes)

  routes = routes.concat(departureRoutes(user))

  if (user.authorities.includes('FINANZEN')) routes = routes.concat(finanzenDepartmentRoutes)

  if (user.authorities.includes('ZIMMER')) routes = routes.concat(zimmerDepartmentRoutes)

  if (user.authorities.includes('INFO')) routes = routes.concat(infoDepartmentRoutes)

  if (user.authorities.includes('SCHLICHTUNG')) routes = routes.concat(schlichtungDepartmentRoutes)

  if (user.authorities.includes('TENANT')) routes = routes.concat(individualTenantRoutes)

  let map = routes.reduce(function(result, item) {
    result[item.name] = result[item.name] || []
    result[item.name].push(item)
    return result
  }, {})

  return Object.values(map).map(entry => entry[0])
}

export default function Layout({ user }) {
  const classes = useStyles()

  const routes = determineUserRoutes(user)

  const switchRoutes = (
    <Switch>
      {routes.map((prop, key) => {
        return <AuthenticatedRoute path={prop.path} appProps={prop.additionalProps}
                                   component={prop.component} key={key}/>
      })}
    </Switch>
  )

  const mainPanel = createRef()

  const [mobileOpen, setMobileOpen] = useState(false)

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen)
  }

  return (
    <React.Fragment>
      <Redirect to={routes[0].path}/>
      <div className={classes.wrapper}>
        <Sidebar
          routes={routes}
          logoText={'Schollheim'}
          logo={logo}
          handleDrawerToggle={handleDrawerToggle}
          open={mobileOpen}
          color={'burgundy'}
        />
        <div className={classes.mainPanel} ref={mainPanel}>
          <Navbar routes={routes} handleDrawerToggle={handleDrawerToggle}/>
          <div className={classes.content}>
            <div className={classes.container}>{switchRoutes}</div>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}
